export const InnoCardCssString = `
.pt-inno-card {
    border-radius: 12px;
    position: relative;
    display: flex;
    overflow: hidden;
    border: 2px solid #fff;
    box-shadow: 0 0 4px 0 rgba(29, 136, 32, 0.08), 0 8px 20px 0 rgba(29, 136, 32, 0.04);
    cursor: pointer;
}

/* 大尺寸模版 */
.pt-inno-card.large {
    height: 156px;
    justify-content: space-between;
    background-color: rgba(255, 255, 255, 0.6);
}

.pt-inno-card.large .pt-inno-card__btn {
    position: absolute;
    bottom: 24px;
}

.pt-inno-card.large .pt-inno-card__img {
    max-width: 680px;
    height: 154px;
}

/* 小尺寸模版 */
.pt-inno-card.mini {
    height: 80px;
    align-items: center;
    justify-content: center;
}

.pt-inno-card.mini .pt-inno-card__close {
    top: 50%;
    margin-top: -8px;
}

.pt-inno-card.mini .pt-inno-card__img {
    width: 100%;
    height: 80px;
    position: absolute;
    top: -2px;
    left: 0;
    z-index: -1;
}

.pt-inno-card.mini .pt-inno-card__title {
    margin-right: 24px;
}

.pt-inno-card .pt-inno-card__info {
    padding: 22px;
    max-width: 60%;
}

.pt-inno-card .pt-inno-card__title {
    max-height: 48px;
    line-height: 24px;
    font-size: 18px;
    font-weight: 600;
}

.pt-inno-card .pt-inno-card__title > span {
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
}

.pt-inno-card .pt-inno-card__img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.pt-inno-card .pt-inno-card__img img {
    height: 100%;
}

.pt-inno-card .pt-inno-card__desc {
    margin-top: 8px;
    line-height: 16px;
    font-size: 12px;
    height: 32px;
    color: #8993a4;
}

.pt-inno-card .pt-inno-card__desc > span {
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
}

.pt-inno-card .pt-inno-card__btn {
    padding: 0 8px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
}

.pt-inno-card .pt-inno-card__btn-label {
    margin-right: 4px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}

.pt-inno-card .pt-inno-card__close {
    height: 16px;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
`;
//# sourceMappingURL=style.js.map